module.exports = __webpack_public_path__ + "static/img/4.a9934d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/medio-ambiente-en/4.png
// module id = mBW+
// module chunks = 0